import { Component, inject, input, OnInit, output, signal, ViewChild } from '@angular/core';
import { CHANNEL_QUOTE_ENUM } from '@webapp/core/config';
import { PAYMENT_GATEWAYS } from '../../../core/constants/constants';
import {
  IPayment,
  IPaymentItem,
} from '@webapp/quoter//interfaces/payment.interface';
import { AddCreditCardComponent } from '../add-credit-card/add-credit-card.component';
import { AddCbuComponent } from '../add-cbu/add-cbu.component';
import { PaymentItemComponent } from '../payment-item/payment-item.component';
import { CHANNEL } from '@webapp/core/config';

@Component({
  selector: 'app-add-payment',
  standalone: true,
  imports: [AddCreditCardComponent, AddCbuComponent, PaymentItemComponent],
  templateUrl: './add-payment.component.html',
  styleUrl: './add-payment.component.scss',
})
export class AddPaymentComponent implements OnInit {
  EventPaymentSubmit = output<IPayment>();
  selectedPaymentType = signal<IPaymentItem>({} as IPaymentItem);
  paymentItems = signal<IPaymentItem[]>([]);
  paymentGateways = input<string[]>();
  needSecurityCode = input<boolean>();
  loading = input(false);
  channel = inject(CHANNEL);
  @ViewChild(AddCreditCardComponent) addCreditCardComponent?: AddCreditCardComponent;
  @ViewChild(AddCbuComponent) addCbuComponent?: AddCbuComponent;
  ngOnInit(): void {
    this.paymentItems.set([
      {
        name: 'Tarjeta de crédito',
        icon: 'images/credit-card.svg',
        selected: false,
        tag: 'credit_card',
      },
      ...(this.paymentGateways()?.includes(PAYMENT_GATEWAYS.MERIDIONAL) &&
        !this.paymentGateways()?.includes(PAYMENT_GATEWAYS.MERCADO_PAGO) && this.channel === CHANNEL_QUOTE_ENUM.AGENTS
        ? [
          {
            name: 'Débito en cuenta',
            icon: 'images/bank.svg',
            selected: false,
            tag: 'cbu',
          },
        ]
        : []),
    ]);

    // Always pre-select the credit card option (first item)
    this.setPaymentType(this.paymentItems()[0]);
  }

  setPaymentType(payment: IPaymentItem) {
    this.paymentItems().map((item) => {
      item.selected = false;
    });
    payment.selected = true;
    this.selectedPaymentType.set(payment);
  }

  setPayment(payment: IPayment) {
    this.EventPaymentSubmit.emit(payment);
  }
  
}
